export const APP_NAME = "databull";
export const APP_NAME_FULL = "databull";
